<div class="header-box" [ngClass]="id ? 'with-info-box' : ''">
  <div class="d-flex align-items-center heading-box">
    <ng-icon
      [name]="mode == 'view' ? 'heroDocumentMagnifyingGlass' : (mode == 'edit' ? 'heroPencilSquare' : 'heroDocumentPlus')"></ng-icon>
    <div>
      <h2 *ngIf="mode"><small>{{ mode + ' Contract' | titlecase }}</small></h2>
      <h2 *ngIf="formLoading; else loaded"><ngx-skeleton-loader
          [theme]="{ height: '20px', width: '200px'}"></ngx-skeleton-loader></h2>
      <ng-template #loaded>
        <h2>{{ id ? contract.name : 'Initiate Contract'}}</h2>
      </ng-template>
    </div>
  </div>
  <div class="d-flex justify-content-end align-items-center col-md-6 p-0"
    *ngIf="contract?.createdBy == userService?.loggedinUser?.id">
    <button color="warn" mat-raised-button
      *ngIf="contract?.statusId === 5 && id" 
      (click)="recallContract()"
      class="mr-3" 
      [disabled]="isLoading">
      Recall
      <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
    </button>
    <button color="accent" mat-raised-button
      *ngIf="!contract?.isMandatoryFilled && contract?.transactionTypeId == 1 && id && isValidationStep()" (click)="generateDoc()"
      class="mr-3" [disabled]="isLoading">
      Generate Document
      <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
    </button>
    <button color="accent" mat-raised-button
      *ngIf="userService.permissionsValue['_CONTRACT_'+ contract.contractTypeName?.toUpperCase() + '_EDIT_'] && mode == 'view'"
      [routerLink]="['/app/contract','edit',id]">
      Edit Contract</button>
  </div>
</div>
<div class="info-box" *ngIf="id">
  <div class="info-section">
    <h3><small>Contract Id</small></h3>
    <h3 *ngIf="formLoading; else loadedId"><ngx-skeleton-loader
        [theme]="{ height: '15px', width: '150px'}"></ngx-skeleton-loader></h3>
    <ng-template #loadedId>
      <h3>{{contract.id}}</h3>
    </ng-template>
  </div>
  <div class="info-section">
    <h3><small>Contract Status</small></h3>
    <h3 *ngIf="formLoading; else loadedStatus"><ngx-skeleton-loader
        [theme]="{ height: '15px', width: '150px'}"></ngx-skeleton-loader></h3>
    <ng-template #loadedStatus>
      <h3>{{contract.statusName ? contract.statusName : 'Initiated'}}</h3>
    </ng-template>
  </div>
  <div class="info-section" *ngIf="mode">
    <h3><small>Contract Owner</small></h3>
    <h3 *ngIf="formLoading; else loadedName"><ngx-skeleton-loader
        [theme]="{ height: '15px', width: '150px'}"></ngx-skeleton-loader></h3>
    <ng-template #loadedName>
      <h3>{{contract.createdByName}}</h3>
    </ng-template>
  </div>
</div>
<div class="inner-box">
  <mat-card>
    <mat-card-content class="form-head">
      <div *ngIf="formLoading; else show" class="form-skeleton">
        <ngx-skeleton-loader [theme]="{ height: '80px', width: '70%', margin: '0 auto'}"></ngx-skeleton-loader>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '50px', width: '10%', float: 'right'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader
            [theme]="{ height: '50px', width: '30px', opacity: '0', float: 'right', visibility: 'hidden'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{ height: '50px', width: '10%', float: 'right'}"></ngx-skeleton-loader>
        </div>
      </div>
      <ng-template #show>
        <mat-stepper [linear]="mode != 'view'" #stepper [disableRipple]="true" class="full-width"
          (selectionChange)="selectionChange($event)"
          [selectedIndex]="id && mode == 'edit' ? (contract.completedStep > 3 ? (contract.transactionTypeId == 1 ? 3 : 2) : contract.completedStep) : (id && mode == 'view' ? (contract.transactionTypeId == 1 ? 3 : 2) : 0)">
          <mat-step [stepControl]="contractForm" [completed]="contractForm.valid">
            <form [formGroup]="contractForm">
              <mat-accordion>
                <mat-expansion-panel expanded hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ id && mode ? (mode + ' Contract' | titlecase) : 'Enter Contract Details' }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ng-template matStepLabel>Contract Info</ng-template>
                  <div class="col-md-12 d-flex p-0">
                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Contract Type</mat-label>
                          <input type="text" placeholder="Select Contract Type" matInput [matAutocomplete]="auto"
                            formControlName="contractTypeName" (input)="onInputChange($event.target.value)"
                            #contractInput>
                          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onContractTypeSelect($event)">
                            <mat-option disabled *ngIf="isNotFound">No Items Found</mat-option>
                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                              {{option.name}}
                            </mat-option>
                          </mat-autocomplete>
                          <mat-error *ngIf="contractForm.get('contractTypeName')?.hasError('required')">
                            Contract Type is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Legal Template Type</mat-label>
                          <mat-select formControlName="transactionTypeId" [errorStateMatcher]="matcher">
                            <mat-option *ngFor="let trans of transactions" [value]="trans.id">{{ trans.name
                              }}</mat-option>
                          </mat-select>
                          <mat-error *ngIf="contractForm.get('transactionTypeId')?.hasError('required')">
                            Legal Template Type is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 d-flex p-0">
                  <div class="col-md-4">
                    <div class="dense-2">
                      <mat-form-field appearance="outline">
                        <mat-label>Contract Name</mat-label>
                        <input type="text" matInput autocomplete="off" formControlName="name"
                          [errorStateMatcher]="matcher">
                        <mat-error *ngIf="contractForm.get('name')?.hasError('required')">
                          Contract Name is required
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="dense-2">
                      <mat-form-field appearance="outline">
                        <mat-label>Account Name</mat-label>
                        <mat-select formControlName="accountId" [errorStateMatcher]="matcher">
                          <mat-option *ngFor="let account of accountList" [value]="account.id">
                            {{ account.name }}
                          </mat-option>
                        </mat-select>
                        <!-- <mat-error *ngIf="contractForm.get('accountId')?.hasError('required')">
                          Account Name is required
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
              <div class="d-flex col-md-12 justify-content-end p-0">
                <button color="accent" mat-raised-button class="" matStepperNext 
                  *ngIf="!isFormChanged && id" 
                  [disabled]="!contractForm.valid || isLoading">Next
                </button>
                <button color="accent" mat-raised-button (click)="createContract()" *ngIf="isFormChanged || !id"
                  [disabled]="isLoading || !contractForm.valid">{{
                  id ? 'Update & Next' : 'Save & Next' }}
                  <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                </button>
              </div>
            </form>
          </mat-step>

          <mat-step [stepControl]="metadataForm" label="Enter Data"
            [completed]="metadataForm.valid && values.length > 0">
            <div class="d-flex justify-content-end mt-3 align-items-center">
              <!-- Add response time display -->
              <div class="response-time-box" *ngIf="responseTime" title="AI Processing Time">
                <mat-icon>timer</mat-icon>
                <span>It just took {{ responseTime }}s to extract the data</span>
              </div>
              <button color="accent" mat-raised-button
                *ngIf="mode != 'view' && contract?.createdBy == userService?.loggedinUser?.id && contractForm.get('transactionTypeId')?.value != 1"
                (click)="uploadPDF.click()" class="ml-3" [disabled]="isLoading">
                Upload Existing Contract
                <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
              </button>
            </div>
            <input type="file" accept=".docx, .pdf" style="display: none" #uploadPDF
              (change)="handlePDFUpload($event.target.files)">
            <form [formGroup]="metadataForm">
              <mat-accordion>
                <ng-container *ngFor="let sectionName of sectionNames, let i=index">
                  <mat-expansion-panel *ngIf="hasSectionContent(sectionName)"
                    [expanded]="step === i"
                    (opened)="setStep(i)">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ sequentialSectionNames[i] }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="flex-wrap d-flex p-0" [formGroup]="metadataForm.controls[sectionName]">
                    <div class="col-md-4" *ngFor="let attr of attributesBySection[sectionName]">
                      <div class="dense-2" *ngIf="!attr.isHidden">
                        <mat-form-field appearance="outline" *ngIf="[1,3,6,7,8,10].includes(attr.metaDataTypeId)">
                          <mat-label>{{ attr.label }}</mat-label>

                          <input type="text" *ngIf="attr.metaDataTypeId == 1 || attr.metaDataTypeId == 10" matInput
                            [formControlName]="attr.label" />

                          <input type="url" *ngIf="attr.metaDataTypeId == 8" matInput [formControlName]="attr.label"
                            pattern="^(?:(?:https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)|www\.[a-zA-Z0-9()]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*))$" />

                          <input type="number" *ngIf="attr.metaDataTypeId == 3" matInput [formControlName]="attr.label"
                            min="0" pattern="^\d+$" />

                          <input type="number" *ngIf="attr.metaDataTypeId == 6" matInput [formControlName]="attr.label"
                            inputmode="decimal" pattern="^\d*\.?\d*$" placeholder="0.1" step="0.1" min="0" />

                          <input matInput type="text" matInput [formControlName]="attr.label" placeholder="$0.01"
                            (input)="formatCurrency($event, metadataForm.controls[sectionName].get(attr.label))"
                            *ngIf="attr.metaDataTypeId == 7" />

                          <mat-icon *ngIf="!metadataForm.controls[sectionName].get(attr.label)?.value && attr.helpText"
                            matSuffix matTooltip="{{ attr.helpText }}" [matTooltipShowDelay]="300"
                            [matTooltipHideDelay]="100"><ng-icon name="heroQuestionMarkCircle"></ng-icon></mat-icon>
                          <mat-error *ngIf="metadataForm.controls[sectionName].get(attr.label)?.hasError('required')">
                            {{ attr.label }} is required.
                          </mat-error>
                          <mat-error
                            *ngIf="attr.metaDataTypeId == 7 && metadataForm.controls[sectionName].get(attr.label)?.value && metadataForm.controls[sectionName].get(attr.label)?.invalid">
                            Please enter currency symbol and then currency value in numbers, only two decimal numbers
                            are allowed.
                          </mat-error>
                          <mat-error
                            *ngIf="attr.metaDataTypeId == 3 && metadataForm.controls[sectionName].get(attr.label)?.value && metadataForm.controls[sectionName].get(attr.label)?.invalid">
                            Only Non decimal positive numbers are allowed!
                          </mat-error>
                          <mat-error
                            *ngIf="attr.metaDataTypeId == 8 && metadataForm.controls[sectionName].get(attr.label)?.value && metadataForm.controls[sectionName].get(attr.label)?.invalid">
                            Please enter a valid URL
                          </mat-error>
                        </mat-form-field>

                        <!-- Add this section to display chips for fields with multiple suggestions -->
                        <div *ngIf="fieldSuggestions[attr.label] && fieldSuggestions[attr.label].length > 0"
                          class="suggestion-chips">
                          <mat-chip-list>
                            <mat-chip *ngFor="let suggestion of fieldSuggestions[attr.label]"
                              (click)="selectSuggestion(sectionName, attr.label, suggestion)" color="primary" selected>
                              {{ suggestion }}
                            </mat-chip>
                          </mat-chip-list>
                        </div>

                        <mat-form-field appearance="outline" *ngIf="attr.metaDataTypeId == 4">
                          <mat-label>{{ attr.label }}</mat-label>
                          <textarea matInput [formControlName]="attr.label" cdkTextareaAutosize cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="5" [errorStateMatcher]="matcher"></textarea>
                          <mat-icon *ngIf="!metadataForm.controls[sectionName].get(attr.label)?.value && attr.helpText"
                            matSuffix matTooltip="{{ attr.helpText }}" [matTooltipShowDelay]="300"
                            [matTooltipHideDelay]="100"><ng-icon name="heroQuestionMarkCircle"></ng-icon></mat-icon>
                          <mat-error *ngIf="metadataForm.controls[sectionName].get(attr.label)?.hasError('required')">
                            {{ attr.label }} is required.
                          </mat-error>
                        </mat-form-field>


                        <mat-form-field appearance="outline" *ngIf="attr.metaDataTypeId == 9">
                          <mat-label>{{ attr.label }}</mat-label>
                          <input matInput [matDatepicker]="picker" autocomplete="off" [formControlName]="attr.label"
                            [errorStateMatcher]="matcher">
                          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>

                          <mat-error *ngIf="metadataForm.controls[sectionName].get(attr.label)?.hasError('required')">
                            {{ attr.label }} is required
                          </mat-error>
                          <mat-error
                            *ngIf="metadataForm.controls[sectionName].get(attr.label)?.invalid && metadataForm.controls[sectionName].get(attr.label)?.value">
                            {{ attr.label }} is invalid
                          </mat-error>
                        </mat-form-field>

                        <div class="d-flex flex-column switch-section" *ngIf="attr.metaDataTypeId == 12">
                          <mat-label>{{ attr.label }}</mat-label>
                          <label class="switch">
                            <input class="switch-input" type="checkbox" [formControlName]="attr.label"
                              (change)="updateBooleanFormControlValue(sectionName, attr.label, $event.target.checked, attr.metaDataValues)">
                            <div class="switch-button">
                              <span class="switch-button-left">{{ getMetaDataValues(attr.metaDataValues, 0) }}</span>
                              <span class="switch-button-right">{{ getMetaDataValues(attr.metaDataValues, 1) }}</span>
                            </div>
                          </label>
                        </div>

                        <mat-form-field appearance="outline"
                          *ngIf="attr.metaDataTypeId == 2 || attr.metaDataTypeId == 15">
                          <mat-label>{{ attr.label }}</mat-label>
                          <mat-select [formControlName]="attr.label" [errorStateMatcher]="matcher"
                            multiple="{{ attr.metaDataTypeId == 15 ? true : false }}">
                            <mat-option *ngFor="let data of getMetaDataValues(attr.metaDataValues)" [value]="data">{{
                              data }}</mat-option>
                          </mat-select>
                          <mat-error *ngIf="metadataForm.controls[sectionName].get(attr.label)?.hasError('required')">
                            {{ attr.label }} is required
                          </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" *ngIf="attr.metaDataTypeId == 5">
                          <div class="editor-container">
                            <angular-editor [formControlName]="attr.label" [config]="editorConfig"
                              [placeholder]="attr.label"></angular-editor>
                          </div>
                          <input matInput style="display: none;" [formControlName]="attr.label">
                          <mat-error *ngIf="metadataForm.controls[sectionName].get(attr.label)?.hasError('required')">
                            {{ attr.label }} is required
                          </mat-error>
                        </mat-form-field>

                        <div *ngIf="fieldSuggestions[attr.label] && fieldSuggestions[attr.label].length > 0"
                          class="suggestion-chips">
                          <mat-chip-list>
                            <mat-chip *ngFor="let suggestion of fieldSuggestions[attr.label]"
                              (click)="selectSuggestion(sectionName, attr.label, suggestion)" color="primary" selected
                              [matTooltip]="suggestion" [matTooltipShowDelay]="100" [matTooltipHideDelay]="100">
                              {{ suggestion.length > 20 ? (suggestion.substring(0, 20) + '...') : suggestion }}
                            </mat-chip>
                          </mat-chip-list>
                        </div>
                      </div>
                    </div>
                  </div>
                  <mat-action-row *ngIf="step !== 0 && step !== sectionNames.length - 1">
                    <button mat-button color="primary" (click)="prevStep()">Previous</button>
                    <button mat-button color="accent" (click)="nextStep()">Next</button>
                  </mat-action-row>

                  <mat-action-row *ngIf="step === 0 && sectionNames.length > 1">
                    <button mat-button color="accent" (click)="nextStep()">Next</button>
                  </mat-action-row>

                  <mat-action-row *ngIf="step === sectionNames.length - 1 && sectionNames.length > 1">
                    <button mat-button color="primary" (click)="prevStep()">Previous</button>
                  </mat-action-row>
                </mat-expansion-panel>
                </ng-container>
              </mat-accordion>

              <div class="d-flex col-md-12 justify-content-between p-0">
                <button mat-raised-button color="primary" class="outlined-btn" matStepperPrevious
                  [disabled]="isLoading">Back</button>
                <button color="accent" mat-raised-button (click)="saveAttributeData()" *ngIf="mode != 'view'"
                  class="ml-3" [disabled]="isLoading">{{ values.length > 0 ? 'Update & Next' : 'Save & Next'
                  }}
                  <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                </button>
              </div>
            </form>
          </mat-step>

          <mat-step [stepControl]="templateForm" [completed]="templateForm.valid"
            *ngIf="contract.transactionTypeId == 1">
            <ng-template matStepLabel>{{ contract.transactionTypeId == 1 ? 'Select Template' : 'Upload Document'
              }}</ng-template>

            <div class="col-md-12 p-0 common-table-style">
              <mat-table class="template-table" [dataSource]="dataSource" matSort
                (matSortChange)="customSortData($event)">
                <ng-container matColumnDef="select">
                  <mat-header-cell *matHeaderCellDef>
                    Select
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="onRowSelect(element.templateId)"
                      [checked]="selection.isSelected(element.templateId)" color="primary" [disabled]="mode == 'view'">
                    </mat-checkbox>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Template Name">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Template Name</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    {{ element.templateName }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Description">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Description</mat-header-cell>
                  <mat-cell *matCellDef="let element">{{ element.description }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Version">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Version</mat-header-cell>
                  <mat-cell *matCellDef="let element">{{ element.version }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Last Updated">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    {{ element.updatedDate }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Download">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Download</mat-header-cell>
                  <mat-cell *matCellDef="let element" class="action">
                    <a mat-button color="accent" disableRipple (click)="downloadTemplate(element.templateId)"
                      matTooltip="Download Template {{ element.templateName }}" [matTooltipShowDelay]="300"
                      [matTooltipHideDelay]="100">
                      <mat-progress-spinner *ngIf="downloadLoading[element.templateId]; else go" mode="indeterminate"
                        color="accent" diameter="24"></mat-progress-spinner>
                      <ng-template #go><ng-icon name="heroArrowDownTray"></ng-icon></ng-template>
                    </a>
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

              </mat-table>

              <ng-container *ngIf="dataLoading">
                <div class="skeleton-box">
                  <ngx-skeleton-loader [theme]="{height: '200px'}"></ngx-skeleton-loader>
                </div>
              </ng-container>

              <ng-container *ngIf="dataSource.data.length === 0 && !dataLoading">
                <div class="no-data">
                  <h4>No Data Found</h4>
                  <p>There are no templates available</p>
                </div>
              </ng-container>

              <ng-container *ngIf="dataSource.data.length === 0 && dataSource.filter">
                <div class="no-data">
                  <h4>No Data Found</h4>
                  <p>There are no templates found with <strong>'{{dataSource.filter}}'</strong></p>
                </div>
              </ng-container>

              <!-- Paginator inside table container -->
              <mat-paginator #templatePaginator [pageSizeOptions]="[10, 30, 50]" [pageSize]="10" showFirstLastButtons>
              </mat-paginator>
            </div>

            <div class="d-flex col-md-12 justify-content-between p-0">
              <button mat-raised-button color="primary" class="outlined-btn" matStepperPrevious
                [disabled]="isLoading">Back</button>
              <div>
                <button color="accent" mat-raised-button (click)="updateTemplate()"
                  *ngIf="mode != 'view' && contract?.templateId != selectedTemplateId" class="ml-3"
                  [disabled]="isLoading || !selectedTemplateId">{{ mode ? 'Update & Next' : 'Save
                  & Next' }}
                  <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                </button>
                <button color="accent" mat-raised-button class="ml-3" *ngIf="contract?.templateId == selectedTemplateId"
                  matStepperNext [disabled]="isLoading || !selectedTemplateId">Next
                  <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                </button>
                
              </div>
            </div>
          </mat-step>

          <mat-step [completed]="contract.isMandatoryFilled">
            <ng-template matStepLabel>Validation</ng-template>
            <mat-tab-group dynamicHeight (selectedTabChange)="onTabClick($event)">
              <mat-tab label="Summary">
                <div class="row summary" style="margin:2px">
                  <div class="col-md-5">
                    <mat-card>
                      <mat-card-header>
                        <mat-card-title>Contract Summary</mat-card-title>
                      </mat-card-header>
                      <mat-card-content class="contract-summary">
                        <div *ngIf="contractSummary.length > 0">
                          <ng-container *ngFor="let section of contractSummary | groupBy: 'sectionName'">
                            <h5>{{ removeSerial(section.key) }}</h5>
                            <table class="table">
                              <tbody>
                                <tr *ngFor="let attr of section.value">
                                  <th>{{ attr.attributeLabel }}</th>
                                  <td>{{ attr.attributeLabel.includes("Date") ? (attr.attributeValue ?
                                    formatDate(attr.attributeValue) : '-' ) : (attr.attributeValue ?? '-' ) }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </ng-container>
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </div>
                  <div class="col-md-7">
                    <mat-card>
                      <mat-card-header>
                        <mat-card-title>Document Preview</mat-card-title>
                      </mat-card-header>
                      <mat-card-content>
                        <ngx-doc-viewer *ngIf="previewURL; else notFound" [url]="previewURL" [viewer]="viewerType"
                          style="width:100%; height:85vh;"></ngx-doc-viewer>
                        <ng-template #notFound>
                          <div class="no-data" style="width:100%; height:50vh;">
                            <h4>No File Found</h4>
                            <p>Please upload or generate the file to see the preview</p>
                          </div>
                        </ng-template>
                      </mat-card-content>
                    </mat-card>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Details" class="table-summary">
                <mat-card *ngFor="let section of contractDetails | groupBy: 'sectionName'">
                  <mat-card-content class="contract-summary">
                    <div>
                      <h4>{{ section.key }}</h4>
                      <table class="table">
                        <tbody>
                          <tr *ngFor="let attr of section.value">
                            <th>{{ attr.attributeLabel }}</th>
                            <td>{{ attr.attributeLabel.includes("Date") ? (attr.attributeValue ?
                              formatDate(attr.attributeValue) : '-' ) : (attr.attributeValue ?? '-' ) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </mat-card-content>
                </mat-card>
              </mat-tab>
              <mat-tab label="Teams">
                <mat-tab-group class="child-tab" color="accent" (selectedTabChange)="onTeamsTabClick($event)">
                  <mat-tab label="Reviewers">
                    <app-contract-reviewer [contractId]="id" [mode]="mode" [editable]="true"
                      (refreshContract)="getContract()" *ngIf="id && contract.isMandatoryFilled"
                      #reviewerTab></app-contract-reviewer>
                    <!-- <div class="d-flex col-md-12 justify-content-end mt-5" *ngIf="isCurrentReviewer">
                      <button color="accent" mat-raised-button (click)="approveOrReview(2)" class="ml-3"
                        [disabled]="isLoading">
                        Complete Review 
                        <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                      </button>
                      <button color="accent" mat-raised-button (click)="openRejectDialog(2)" class="ml-3"
                        [disabled]="isLoading">
                        Decline
                        <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                      </button>
                    </div> -->
                  </mat-tab>
                  <mat-tab label="Approvers">
                    <app-contract-approvals [contractId]="id" [mode]="mode" [editable]="true"
                      (refreshContract)="getContract()" *ngIf="id && contract.isMandatoryFilled"
                      #approverTab></app-contract-approvals>
                    <!-- <div class="d-flex col-md-12 justify-content-end mt-5" *ngIf="isCurrentApprover">
                      <button color="accent" mat-raised-button (click)="approveOrReview(3)" class="ml-3"
                        [disabled]="isLoading">
                        Approve
                        <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                      </button>
                      <button color="accent" mat-raised-button (click)="openRejectDialog(3)" class="ml-3"
                        [disabled]="isLoading">
                        Reject
                        <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                      </button>
                    </div> -->
                  </mat-tab>
                </mat-tab-group>
              </mat-tab>
              <mat-tab label="Clauses" *ngIf="contract?.isMandatoryFilled">
                <app-contract-clause [contractTypeId]="contract.contractTypeId" [contractId]="contract.id" [editable]
                  [templateId]="contract.templateId" *ngIf="selectedTabIndex === 3"></app-contract-clause>
              </mat-tab>
              <mat-tab label="Supporting Docs" *ngIf="id">
                <app-contract-supporting-documents [contractId]="id" [mode]="mode" [isContractEditPermission]="true"
                  *ngIf="selectedTabIndex === contract.isMandatoryFilled ? 4 : 3"></app-contract-supporting-documents>
              </mat-tab>
              <mat-tab label="Obligations">

                <!-- Contract Approval Status Check -->
                <div class="approval-status mb-4" *ngIf="!isContractEligibleForObligations()">
                  <mat-card class="approval-card">
                    <mat-card-content>
                      <div class="d-flex align-items-center">
                        <mat-icon class="status-icon">info</mat-icon>
                        <div>
                          <h4>Contract Not Approved</h4>
                          <p class="mb-0">{{ getContractApprovalMessage() }}</p>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                </div>

                <!-- Manual Extraction and Add Obligation Buttons -->
                <div class="extraction-controls mb-4"
                  *ngIf="contract?.isMandatoryFilled && mode != 'view' && isContractEligibleForObligations()">
                  <mat-card class="extraction-card">
                    <mat-card-content>
                      <div class="d-flex justify-content-between align-items-center p-2">
                        <div>
                          <h4>Obligation Management</h4>
                          <p class="mb-0">Extract obligations automatically using AI, then select and save the ones you
                            want to keep, or add them manually.</p>
                        </div>
                        <div class="button-group">
                          <button mat-raised-button color="accent" (click)="addNewObligation()">
                            <mat-icon>add</mat-icon>
                            Add Obligation
                          </button>
                          <button mat-raised-button color="primary" (click)="extractObligationsManually()"
                            [disabled]="isAnalyzing" class="d-flex align-items-center">
                            <mat-icon *ngIf="!isAnalyzing" class="mr-2">auto_awesome</mat-icon>
                            <span>{{ isAnalyzing ? 'Extracting...' : 'Extract using AI' }}</span>
                          </button>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                </div>

                <!-- Extraction Loading Indicator -->
                <div class="extraction-loading mb-4" *ngIf="isAnalyzing">
                  <mat-card class="loading-card">
                    <mat-card-content>
                      <div class="loading-content">
                        <mat-spinner diameter="30"></mat-spinner>
                        <h4>Extracting Obligations from Contract Document...</h4>
                        <p>Please wait while we analyze your contract and extract obligations using AI.</p>
                      </div>
                    </mat-card-content>
                  </mat-card>
                </div>


                <!-- Obligation Form -->
                <div *ngIf="showObligationForm">
                  <form [formGroup]="obligationsForm" (ngSubmit)="saveObligations()" class="mb-3"
                    [class.view-mode]="viewMode">
                    <mat-card class="obligation-form-card">
                      <mat-card-header>
                        <div class="d-flex justify-content-between align-items-center w-100">
                          <mat-card-title>
                            {{ viewMode ? 'View Obligation Details' : (currentObligation ? 'Edit Obligation Details' :
                            'Add New Obligation') }}
                          </mat-card-title>
                          <button type="button" mat-icon-button (click)="closeObligationForm()" matTooltip="Close Form">
                            <mat-icon>close</mat-icon>
                          </button>
                        </div>
                      </mat-card-header>
                      <mat-card-content>
                        <!-- First Row: Obligation ID, Contract ID, Section No. & Title -->
                        <div class="obligation-info-row">
                          <div class="info-item">
                            <span class="info-label">Obligation ID</span>
                            <span class="info-value">{{ currentObligation?.['Sr No.'] || currentObligation?.id || 'NA'
                              }}</span>
                          </div>
                          <div class="info-item">
                            <span class="info-label">Contract ID</span>
                            <span class="info-value">{{ contract?.id || 'NA' }}</span>
                          </div>
                          <div class="info-item section-info">
                            <span class="info-label">Section No. & Title</span>
                            <div class="section-display" *ngIf="viewMode">
                              <div class="section-number">{{ obligationsForm.get('sectionNumber')?.value || 'N/A' }}
                              </div>
                            </div>
                            <mat-form-field appearance="outline" class="section-number-field" *ngIf="!viewMode">
                              <input matInput formControlName="sectionNumber" placeholder="Enter Section Number"
                                [errorStateMatcher]="matcher">
                            </mat-form-field>
                          </div>
                        </div>
                        <div class="flex-wrap col-md-12 d-flex p-0">
                          <div class="col-md-2">
                            <div class="dense-2">
                              <mat-form-field appearance="outline" class="status-field">
                                <mat-label>Status</mat-label>
                                <mat-select formControlName="status" [errorStateMatcher]="matcher"
                                  [disabled]="viewMode">
                                  <mat-option value="Draft">Draft</mat-option>
                                  <mat-option value="Active">Active</mat-option>
                                  <mat-option value="Overdue">Overdue</mat-option>
                                  <mat-option value="Fulfilled">Fulfilled</mat-option>
                                  <mat-option value="Cancelled">Cancelled</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="dense-2">
                              <mat-form-field appearance="outline">
                                <mat-label>Obligation Owner (Party Name)</mat-label>
                                <input matInput formControlName="obligationOwner" [errorStateMatcher]="matcher"
                                  [disabled]="viewMode">
                                <mat-error *ngIf="obligationsForm.get('obligationOwner')?.hasError('required')">
                                  Obligation Owner is required
                                </mat-error>
                                <mat-error
                                  *ngIf="obligationsForm.get('obligationOwner')?.hasError('nonEmptyTextRequired')">
                                  Obligation Owner cannot be empty
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="dense-2">
                              <mat-form-field appearance="outline">
                                <mat-label>Obligation Type</mat-label>
                                <input matInput formControlName="obligationType" [errorStateMatcher]="matcher"
                                  [disabled]="viewMode">
                                <mat-error *ngIf="obligationsForm.get('obligationType')?.hasError('required')">
                                  Obligation Type is required
                                </mat-error>
                                <mat-error
                                  *ngIf="obligationsForm.get('obligationType')?.hasError('nonEmptyTextRequired')">
                                  Obligation Type cannot be empty
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                        <!-- Obligation Text -->
                        <div class="col-md-12">
                          <div class="dense-2">
                            <mat-form-field appearance="outline">
                              <mat-label>Obligation Text</mat-label>
                              <textarea matInput formControlName="obligationText" cdkTextareaAutosize
                                cdkAutosizeMinRows="3" cdkAutosizeMaxRows="6"
                                placeholder="Enter obligation text here..." [errorStateMatcher]="matcher"
                                [disabled]="viewMode"></textarea>
                              <mat-error *ngIf="obligationsForm.get('obligationText')?.hasError('required')">
                                Obligation Text is required
                              </mat-error>
                              <mat-error
                                *ngIf="obligationsForm.get('obligationText')?.hasError('meaningfulTextRequired')">
                                Obligation Text must be at least 10 characters long
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>

                        <!-- AI Interpretation - Only show for AI extracted obligations -->
                        <div class="col-md-12">
                          <div class="dense-2">
                            <div class="form-field">
                              <label class="field-label">AI Interpretation of Obligation</label>
                              <div class="ai-interpretation">
                                {{ currentObligation?.description || 'NA' }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Scheduling and Frequency -->
                        <div class="flex-wrap col-md-12 d-flex p-0">
                          <div class="col-md-2">
                            <div class="dense-2">
                              <mat-form-field appearance="outline">
                                <mat-label>Frequency</mat-label>
                                <mat-select formControlName="frequency" [errorStateMatcher]="matcher"
                                  [disabled]="viewMode">
                                  <mat-option value="One-time">One-time</mat-option>
                                  <mat-option value="Weekly">Weekly</mat-option>
                                  <mat-option value="Monthly">Monthly</mat-option>
                                  <mat-option value="Quarterly">Quarterly</mat-option>
                                  <mat-option value="Annually">Annually</mat-option>
                                  <mat-option value="Recurring">Recurring</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>

                          <div class="col-md-2">
                            <div class="dense-2">
                              <mat-form-field appearance="outline">
                                <mat-label>Agreement Start Date</mat-label>
                                <input matInput [matDatepicker]="agreementStartPicker"
                                  formControlName="agreementStartDate" [errorStateMatcher]="matcher"
                                  [disabled]="viewMode">
                                <mat-datepicker-toggle matIconSuffix
                                  [for]="agreementStartPicker"></mat-datepicker-toggle>
                                <mat-datepicker #agreementStartPicker></mat-datepicker>
                                <mat-error *ngIf="obligationsForm.hasError('dateRangeInvalid')">
                                  Start date cannot be greater than end date
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>

                          <div class="col-md-2">
                            <div class="dense-2">
                              <mat-form-field appearance="outline">
                                <mat-label>Agreement End Date</mat-label>
                                <input matInput [matDatepicker]="agreementEndPicker" formControlName="agreementEndDate"
                                  [errorStateMatcher]="matcher" [disabled]="viewMode">
                                <mat-datepicker-toggle matIconSuffix [for]="agreementEndPicker"></mat-datepicker-toggle>
                                <mat-datepicker #agreementEndPicker></mat-datepicker>
                                <mat-error *ngIf="obligationsForm.hasError('dateRangeInvalid')">
                                  End date cannot be earlier than start date
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="dense-2">
                              <mat-form-field appearance="outline">
                                <mat-label>Target Date</mat-label>
                                <input matInput [matDatepicker]="targetPicker" formControlName="targetDate"
                                  [errorStateMatcher]="matcher"
                                  [disabled]="obligationsForm.get('frequency')?.value !== 'One-time' || viewMode">
                                <mat-datepicker-toggle matIconSuffix [for]="targetPicker"></mat-datepicker-toggle>
                                <mat-datepicker #targetPicker></mat-datepicker>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>

                        <!-- Responsible Person and Advance Reminder -->
                        <div class="flex-wrap col-md-12 d-flex p-0">
                          <div class="col-md-6">
                            <div class="dense-2">
                              <mat-form-field appearance="outline">
                                <mat-label>Responsible Person Email / User</mat-label>
                                <input matInput formControlName="responsiblePersonEmail"
                                  placeholder="Enter Responsible Person Email / User" [errorStateMatcher]="matcher"
                                  [disabled]="viewMode">
                                <button mat-icon-button matSuffix type="button" class="add-user-btn"
                                  (click)="openResponsiblePersonModal()" [disabled]="viewMode">
                                  <mat-icon>person_add</mat-icon>
                                </button>
                                <mat-error *ngIf="obligationsForm.get('responsiblePersonEmail')?.hasError('required')">
                                  Responsible Person Email is required
                                </mat-error>
                                <mat-error *ngIf="obligationsForm.get('responsiblePersonEmail')?.hasError('email')">
                                  Please enter a valid email address
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="dense-2">
                              <mat-form-field appearance="outline">
                                <mat-label>Advance Reminder</mat-label>
                                <mat-select formControlName="advanceReminder" placeholder="Select reminder period"
                                  [disabled]="viewMode">
                                  <mat-option value="7">7 days</mat-option>
                                  <mat-option value="15">15 days</mat-option>
                                  <mat-option value="30">30 days</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>

                        <!-- Fulfillment Section -->
                        <div class="fulfillment-section">
                          <div class="fulfillment-header">
                            <h6 class="section-title">
                              <mat-icon>attach_file</mat-icon>
                              Fulfillment Documentation
                            </h6>
                          </div>

                          <div class="fulfillment-content">
                            <div class="fulfillment-description">
                              <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Fulfillment Description</mat-label>
                                <input matInput formControlName="fulfillmentDescription"
                                  placeholder="Enter a description for the fulfillment document..."
                                  [errorStateMatcher]="matcher" [disabled]="viewMode">
                                <mat-hint>Describe what this fulfillment document represents</mat-hint>
                              </mat-form-field>
                            </div>

                            <div class="fulfillment-actions">
                              <!-- File Upload -->
                              <input type="file" #fulfillmentFileInput
                                accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.gif,.bmp,.tiff,.txt,.csv,.zip,.rar,.7z"
                                (change)="onFulfillmentFileSelected($event)" style="display: none">

                              <div class="action-buttons">
                                <button mat-raised-button color="accent" type="button" class="action-btn upload-btn"
                                  [disabled]="fulfillmentFileUploading || viewMode"
                                  (click)="fulfillmentFileInput.click()">
                                  <mat-icon>cloud_upload</mat-icon>
                                  <span>{{ fulfillmentFileUploading ? 'Uploading...' : 'Select File' }}</span>
                                  <mat-spinner *ngIf="fulfillmentFileUploading" diameter="18"
                                    class="ml-2"></mat-spinner>
                                </button>

                                <button mat-raised-button color="primary" type="button" class="action-btn save-btn"
                                  [disabled]="!fulfillmentFile || fulfillmentFileUploading || viewMode"
                                  (click)="uploadFulfillmentFile()">
                                  <mat-icon>save</mat-icon>
                                  <span>Upload Fulfillment Proof</span>
                                </button>

                                <button mat-raised-button color="warn" type="button" class="action-btn download-btn"
                                  *ngIf="currentObligation?.id && hasFulfillmentFile(currentObligation.id)"
                                  [disabled]="fulfillmentFileDownloading"
                                  (click)="downloadFulfillmentFile(currentObligation.id)">
                                  <mat-icon>cloud_download</mat-icon>
                                  <span>{{ fulfillmentFileDownloading ? 'Downloading...' : 'Download' }}</span>
                                  <mat-spinner *ngIf="fulfillmentFileDownloading" diameter="18"
                                    class="ml-2"></mat-spinner>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Selected File Display -->
                        <div class="selected-file-container" *ngIf="fulfillmentFile">
                          <div class="selected-file-card">
                            <div class="file-preview">
                              <div class="file-icon-container">
                                <mat-icon class="file-icon">{{ getFileIcon(fulfillmentFile.type) }}</mat-icon>
                              </div>
                              <div class="file-details">
                                <div class="file-name">{{ fulfillmentFile.name }}</div>
                                <div class="file-meta">
                                  <span class="file-type-badge">{{ getFileTypeDisplay(fulfillmentFile.type) }}</span>
                                  <span class="file-size">{{ formatFileSize(fulfillmentFile.size) }}</span>
                                </div>
                              </div>
                            </div>
                            <div class="file-actions">
                              <button mat-icon-button color="warn" type="button" class="remove-btn"
                                [disabled]="fulfillmentFileUploading" (click)="removeSelectedFile()"
                                matTooltip="Remove selected file">
                                <mat-icon>close</mat-icon>
                              </button>
                            </div>
                          </div>
                        </div>
                      </mat-card-content>
                      <mat-card-actions align="end" *ngIf="!viewMode && mode !='view'">
                        <button color="primary" mat-raised-button [disabled]="isLoading" class="outlined-btn"
                          (click)="resetObligationForm()" type="button">Reset
                          <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                        </button>
                        <button color="accent" class="ml-3" mat-raised-button type="submit" [disabled]="isLoading">{{
                          obligationsForm.get('id').value ? 'Update' : 'Submit' }}
                          <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                        </button>
                      </mat-card-actions>
                    </mat-card>
                  </form>
                </div>

                <!-- Obligations Table -->
                <div class="col-md-12 common-table-style"
                  *ngIf="isContractEligibleForObligations() && obligationData && obligationData.length > 0">
                  <mat-card class="obligations-table-card">
                    <!-- Bulk Actions Toolbar -->
                    <mat-card-header *ngIf="selectedObligations && selectedObligations.length > 0"
                      class="bulk-actions-toolbar">
                      <div class="d-flex justify-content-between align-items-center w-100">
                        <div class="selected-count">
                          <mat-icon>check_circle</mat-icon>
                          <span>{{ selectedObligations.length }} obligation(s) selected</span>
                        </div>
                        <div class="bulk-actions">
                          <button mat-raised-button color="primary" (click)="clearObligationSelection()">
                            <mat-icon>clear</mat-icon>
                            Clear Selection
                          </button>
                          <button mat-raised-button color="warn" (click)="deleteSelectedObligations()"
                            [disabled]="isLoading">
                            <mat-icon>delete</mat-icon>
                            Delete Selected
                          </button>
                        </div>
                      </div>
                    </mat-card-header>

                    <mat-card-content>
                      <div class="table-container">
                        <p-table [value]="obligationData" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
                          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                          [rowsPerPageOptions]="[5,10,25,50]" [resizableColumns]="true" [sortMode]="'single'"
                          [sortField]="'srNo'" [sortOrder]="1" styleClass="p-datatable-sm" [loading]="dataLoading"
                          [tableStyle]="{'min-width': '80rem'}" selectionMode="multiple"
                          [(selection)]="selectedObligations" (onSelectionChange)="onObligationSelectionChange($event)"
                          [dataKey]="'srNo'">

                          <ng-template pTemplate="header">
                            <tr>
                              <th pResizableColumn style="width: 3rem">
                                <p-tableHeaderCheckbox (onClick)="$event.stopPropagation()"></p-tableHeaderCheckbox>
                              </th>
                              <th pSortableColumn="srNo" pResizableColumn style="width: 8%">
                                Sr No.
                                <p-sortIcon field="srNo"></p-sortIcon>
                              </th>
                              <th pSortableColumn="sectionTitle" pResizableColumn style="width: 12%">
                                Section & Title
                                <p-sortIcon field="sectionTitle"></p-sortIcon>
                              </th>
                              <th pSortableColumn="obligationText" pResizableColumn style="width: 35%">
                                Obligation Text
                                <p-sortIcon field="obligationText"></p-sortIcon>
                              </th>
                              <th pSortableColumn="frequency" pResizableColumn style="width: 8%">
                                Frequency
                                <p-sortIcon field="frequency"></p-sortIcon>
                              </th>
                              <th pSortableColumn="obligationOwner" pResizableColumn style="width: 10%">
                                Obligation Owner
                                <p-sortIcon field="obligationOwner"></p-sortIcon>
                              </th>
                              <th pSortableColumn="responsiblePerson" pResizableColumn style="width: 12%">
                                Owner
                                <p-sortIcon field="responsiblePerson"></p-sortIcon>
                              </th>
                              <th pSortableColumn="status" pResizableColumn style="width: 8%">
                                Status
                                <p-sortIcon field="status"></p-sortIcon>
                              </th>
                              <th pResizableColumn style="width: 10%">
                                Action
                              </th>
                            </tr>
                          </ng-template>

                          <ng-template pTemplate="body" let-element>
                            <tr>
                              <td>
                                <p-tableCheckbox [value]="element"
                                  (onClick)="$event.stopPropagation()"></p-tableCheckbox>
                              </td>
                              <td>{{ element.srNo }}</td>
                              <td>{{ element.sectionTitle }}</td>
                              <td class="obligation-text-cell">
                                <div class="obligation-text-preview" [pTooltip]="element.obligationText"
                                  tooltipPosition="top" [tooltipDisabled]="!element.obligationText"
                                  [tooltipShowDelay]="300" [tooltipHideDelay]="100"
                                  tooltipStyleClass="obligation-text-tooltip">
                                  {{ element.obligationText }}
                                </div>
                              </td>
                              <td>
                                <p-tag
                                  *ngIf="element.frequency && element.frequency !== 'N/A' && element.frequency.trim() !== ''"
                                  [value]="element.frequency" severity="info" styleClass="frequency-badge">
                                </p-tag>
                                <span
                                  *ngIf="!element.frequency || element.frequency === 'N/A' || element.frequency.trim() === ''"
                                  class="no-frequency">-</span>
                              </td>
                              <td>{{ element.obligationOwner }}</td>
                              <td>{{ element.responsiblePerson }}</td>
                              <td>
                                <p-tag [value]="getStatusText(element.status)" severity="info"
                                  styleClass="status-badge draft">
                                </p-tag>
                              </td>
                              <td class="action action-column">
                                <div class="d-flex gap-1">
                                  <button mat-icon-button color="primary" (click)="editObligationFromTable(element)"
                                    *ngIf="mode != 'view'" matTooltip="Edit Obligation">
                                    <mat-icon>edit</mat-icon>
                                  </button>
                                  <button mat-icon-button color="accent" (click)="viewObligationDetails(element)"
                                    matTooltip="View Details">
                                    <mat-icon>visibility</mat-icon>
                                  </button>
                                  <button mat-icon-button [color]="hasFulfillmentFile(element.id) ? 'primary' : 'warn'"
                                    (click)="downloadFulfillmentFile(element.id)"
                                    [matTooltip]="hasFulfillmentFile(element.id) ? 'Download Fulfillment File' : 'No file available'"
                                    [disabled]="fulfillmentFileDownloading || !hasFulfillmentFile(element.id)">
                                    <mat-icon>{{ hasFulfillmentFile(element.id) ? 'cloud_download' : 'cloud_off'
                                      }}</mat-icon>
                                  </button>
                                  <button mat-icon-button color="warn" (click)="deleteObligation(element)"
                                    *ngIf="mode != 'view'" matTooltip="Delete Obligation">
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </ng-template>

                        </p-table>
                      </div>
                    </mat-card-content>
                  </mat-card>

                </div>

                <!-- Loading state -->
                <div class="col-md-12" *ngIf="isContractEligibleForObligations() && dataLoading">
                  <div class="skeleton-box">
                    <ngx-skeleton-loader [theme]="{height: '200px'}"></ngx-skeleton-loader>
                  </div>
                </div>

                <!-- No data state -->
                <div class="col-md-12"
                  *ngIf="isContractEligibleForObligations() && (!obligationData || obligationData.length === 0) && !dataLoading">
                  <div class="no-data">
                    <h4>No Data Found</h4>
                    <p>There are no obligations available</p>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Child Records"></mat-tab>
              <mat-tab label="Notes" *ngIf="id">
                <app-contract-notes [contractId]="id" [mode]="mode" (refreshContract)="getContract()"></app-contract-notes>
              </mat-tab>
              <mat-tab label="History" *ngIf="id">
                <app-contract-history [contractId]="id" #childRef
                  *ngIf="selectedTabIndex === contract.isMandatoryFilled ? 6 : 5"></app-contract-history>
              </mat-tab>
            </mat-tab-group>
            <div class="d-flex col-md-12 justify-content-between p-0">
              <div>
                <button mat-raised-button color="primary" class="outlined-btn" matStepperPrevious
                  [disabled]="isLoading">Back</button>
              </div>
              <div class="d-flex">
                <button color="accent" mat-raised-button
                  *ngIf="contract?.createdBy == userService?.loggedinUser?.id && contract?.statusId == 6"
                  (click)="terminateContract()">Terminate Contract</button>
                <a disableRipple mat-button *ngIf="contract?.isMandatoryFilled" (click)="downloadDoc()"
                  [disabled]="isLoading" class="download-link">
                  <ng-icon name="heroArrowDownTray"></ng-icon> Download Contract
                </a>
                <button color="accent" mat-raised-button
                  *ngIf="(contract.transactionTypeId != 1 || contract.isMandatoryFilled) && [1,4].includes(contract.statusId) && mode != 'view' && contract?.createdBy == userService?.loggedinUser?.id"
                  (click)="uploadFile.click()" class="ml-3" [disabled]="isLoading">
                  Upload Contract
                  <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                </button>
                <input type="file" accept=".doc, .docx, .pdf" style="display: none" #uploadFile
                  (change)="handleFileInput($event.target.files)">

                <button mat-raised-button color="primary" class="outlined-btn" [disabled]="isLoading"
                  (click)="openSignConfirmation()"
                  *ngIf="[3].includes(contract.statusId) && mode != 'view' && contract?.createdBy == userService?.loggedinUser?.id">Mark
                  it Signed
                  <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                </button>

                <button mat-raised-button color="primary" class="outlined-btn ml-3" [disabled]="isLoading"
                  (click)="bypassApproval()"
                  *ngIf="[1,4,9].includes(contract.statusId) && mode != 'view' && contract?.createdBy == userService?.loggedinUser?.id && contract?.isMandatoryFilled">Bypass
                  Approval
                  <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                </button>

                <button color="accent" mat-raised-button
                  *ngIf="[3].includes(contract.statusId) && mode != 'view' && contract?.createdBy == userService?.loggedinUser?.id"
                  (click)="uploadSignedFile.click()" class="ml-3" [disabled]="isLoading">
                  Upload Signed Contract
                  <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                </button>
                <input type="file" accept=".doc, .docx, .pdf" style="display: none" #uploadSignedFile
                  (change)="handleSignedFileInput($event.target.files)">

                <button color="primary" mat-raised-button *ngIf="isCurrentReviewer && contract?.statusId == 8" (click)="openRejectDialog(2)"
                  class="ml-3 outlined-btn" [disabled]="isLoading">
                  Decline
                  <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                </button>
                <button color="accent" mat-raised-button *ngIf="isCurrentReviewer && contract?.statusId == 8" (click)="approveOrReview(2)"
                  class="ml-3" [disabled]="isLoading">
                  Complete Review
                  <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                </button>
                <button color="primary" mat-raised-button *ngIf="isCurrentApprover" (click)="openRejectDialog(3)"
                  class="ml-3 outlined-btn" [disabled]="isLoading">
                  Reject
                  <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                </button>
                <button color="accent" mat-raised-button *ngIf="isCurrentApprover" (click)="approveOrReview(3)"
                  class="ml-3" [disabled]="isLoading">
                  Approve
                  <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                </button>
                <button mat-raised-button color="accent" class="ml-3" matStepperNext
                  [disabled]="isLoading">Next</button>
              </div>
            </div>
          </mat-step>
          <mat-step [completed]="true">
            <div class="revapp-tab">
              <ng-template matStepLabel>Reviewer</ng-template>
              <app-contract-reviewer #reviewerTab [contractId]="id" [mode]="mode" [editable]="false"
                *ngIf="id && contract.isMandatoryFilled && (selectedTabIndex === 3 || selectedTabIndex === 4)"
                (refreshContract)="getContract()"></app-contract-reviewer>
              <div class="d-flex col-md-12 p-0- justify-content-between btns">
                <div>
                  <button mat-raised-button color="primary" class="outlined-btn" matStepperPrevious
                    [disabled]="isLoading">Back</button>
                </div>
                <div>
                  <button color="accent" mat-raised-button *ngIf="isCurrentReviewer && contract?.statusId == 8" (click)="approveOrReview(2)"
                    [disabled]="isLoading">
                    Complete Review
                    <mat-icon matSuffix *ngIf="isLoading"><mat-spinner d iameter="18"></mat-spinner></mat-icon>
                  </button>
                  <button color="accent" mat-raised-button *ngIf="isCurrentReviewer && contract?.statusId == 8" (click)="openRejectDialog(2)"
                    class="ml-3" [disabled]="isLoading">
                    Decline
                    <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                  </button>
                  <button mat-raised-button color="accent" class="ml-3" matStepperNext
                    [disabled]="isLoading">Next</button>
                </div>
              </div>
            </div>
          </mat-step>
          <mat-step [completed]="true">
            <div class="revapp-tab">
              <ng-template matStepLabel>Approvals</ng-template>
              <app-contract-approvals #approverTab [contractId]="id" [mode]="mode" [editable]="false"
                *ngIf="id && contract.isMandatoryFilled && (selectedTabIndex === 5 || selectedTabIndex === 4)"
                (refreshContract)="getContract()"></app-contract-approvals>
              <div class="d-flex col-md-12 justify-content-between btns">
                <div>
                  <button mat-raised-button color="primary" class="outlined-btn" matStepperPrevious
                    [disabled]="isLoading">Back</button>
                </div>
                <div>
                  <button color="accent" mat-raised-button *ngIf="isCurrentApprover" (click)="approveOrReview(3)"
                    [disabled]="isLoading">
                    Approve
                    <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                  </button>
                  <button color="accent" mat-raised-button *ngIf="isCurrentApprover" (click)="openRejectDialog(3)"
                    class="ml-3" [disabled]="isLoading">
                    Reject
                    <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                  </button>
                  <button mat-raised-button color="accent" class="ml-3" matStepperNext
                    [disabled]="isLoading">Next</button>
                </div>
              </div>
            </div>
          </mat-step>
          <mat-step [completed]="[6].includes(contract.statusId)">
            <ng-template matStepLabel>Signatures</ng-template>
            <app-contract-signature #contractSignature [pdfURL]="contractService.downloadDocument(id)" [contractId]="id"
              *ngIf="signatureStepSelected" (refreshContract)="getContract()"></app-contract-signature>
          </mat-step>
        </mat-stepper>
      </ng-template>
    </mat-card-content>
  </mat-card>